import React from 'react'

interface indexProps{
    author: string;
    content: string;
    isYours: boolean;
}

export default function index(props: indexProps) {
    return (
        <div className="message__container">
            <div className={props.isYours ? "message__author author--you": "message__author"}>{props.author}</div>
            <div className={ props.isYours ? " message--yours message__content" : "message--other message__content"}>{props.content}</div>
        </div>
    )
}
